import React, { useState } from 'react';
import styled from 'styled-components';

const ReasoningSteps = ({ steps }) => {
  const [expanded, setExpanded] = useState(false);

  if (!steps || steps.length === 0) return null;

  return (
    <Container>
      <ToggleButton onClick={() => setExpanded(!expanded)}>
        <Icon>{expanded ? '▼' : '▶'}</Icon>
        <Title>View Reasoning Steps</Title>
        <Badge>{steps.length} step{steps.length > 1 ? 's' : ''}</Badge>
      </ToggleButton>
      
      {expanded && (
        <StepsContainer>
          {steps.map((step, index) => (
            <Step key={index}>
              <StepHeader>
                <StepNumber>{index + 1}</StepNumber>
                <StepStage>{step.stage}</StepStage>
              </StepHeader>
              <StepDescription>{step.description}</StepDescription>
              {step.data && (
                <StepData>
                  <pre>{JSON.stringify(step.data, null, 2)}</pre>
                </StepData>
              )}
            </Step>
          ))}
        </StepsContainer>
      )}
    </Container>
  );
};

export default ReasoningSteps;

const Container = styled.div`
  margin: 1rem 0;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  background: #f9f9f9;
`;

const ToggleButton = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: #f0f0f0;
  border: none;
  cursor: pointer;
  transition: background 0.2s;
  
  &:hover {
    background: #e8e8e8;
  }
`;

const Icon = styled.span`
  font-size: 0.8rem;
  color: #666;
`;

const Title = styled.span`
  font-weight: 600;
  color: #333;
  flex-grow: 1;
  text-align: left;
`;

const Badge = styled.span`
  background: #2196F3;
  color: white;
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
`;

const StepsContainer = styled.div`
  padding: 1rem;
  background: white;
`;

const Step = styled.div`
  margin-bottom: 1rem;
  padding: 1rem;
  background: #f8f9fa;
  border-left: 3px solid #2196F3;
  border-radius: 4px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const StepHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.5rem;
`;

const StepNumber = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #2196F3;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 0.9rem;
  flex-shrink: 0;
`;

const StepStage = styled.h4`
  margin: 0;
  font-size: 1rem;
  color: #333;
`;

const StepDescription = styled.p`
  margin: 0.5rem 0;
  color: #555;
  font-size: 0.9rem;
  line-height: 1.5;
`;

const StepData = styled.div`
  margin-top: 0.75rem;
  padding: 0.75rem;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  
  pre {
    margin: 0;
    font-size: 0.8rem;
    color: #444;
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
    overflow-x: auto;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
`;
